import { render, staticRenderFns } from "./_proxy.vue?vue&type=template&id=561f5c75&lang=pug&"
import script from "./_proxy.vue?vue&type=script&lang=js&"
export * from "./_proxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports